import React from 'react';
import RowItemFileDinhKem from './rowitem-filedinhkem.jsx';
import RowItemShowFileDinhKem from './RowItemShowFileDinhKem.jsx';
import { Link } from 'react-router';
import { ShowIf } from 'components/utils';
import { validatable } from 'components/utils';
import { Dialog, Radio, RadioGroup } from "@blueprintjs/core";
import Input from '../tt-forms/common/Input.jsx';
import DatePicker from '../tt-forms/common/DatePicker.jsx';
import moment from 'moment';
import { header } from 'constants/table';
import { isEmpty } from 'lodash'
import emptyFolder from 'assets/images/empty-folder.svg'
import { QuanLyVanBan } from 'api';

class ContainerFileDinhKem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      items: this.props.data,
      itemsShow: this.props.dataShow,
      header: this.props.header,
      validating: this.props.isValid,
      type: this.props.type,
      disableAttachFile: this.props.disableAttachFile,
      tTXMRequired: this.props.tTXMRequired,
      qDGQRequired: this.props.qDGQRequired,
      resetRequired: false,
      loaiDon: this.props.loaiDon,
      onSave: this.props.onSave,
      loaiVanBanSuggest: this.props.loaiVanBanSuggest,
      ngayQuyetDinhSuggest: this.props.ngayQuyetDinhSuggest,
      soVanBanSuggest: this.props.soVanBanSuggest,
      isDsVanBanXuLy: this.props.isDsVanBanXuLy,
      isUploading: false,
      addSuggestions: false,
      isOpen: false,
      loaiVanBan: 'VAN_BAN_DEN',
      tuNgay: '',
      denNgay: '',
      soKyHieu: '',
      loading: false,
      dataTable: [],
      listNhomHoSo: [],
    }
  }

  getListNhomHoSo() {
    QuanLyVanBan.actions.getListNhomHoSo.request().then(res => {
      if (res.data) {
        this.setState({
          listNhomHoSo: res.data
        })
      }
    })
  }

  componentDidMount() {
    this.getListNhomHoSo();
    this.setState({
      items: this.props.data,
      itemsShow: this.props.dataShow
    }, () => {
      if(!this.state.isDsVanBanXuLy) {
        this.addSuggestions();
      }
    });
    if (this.props.tTXMRequired) {
      this.addTTXMRequired(this.props.tTXMText);
    }

    if (this.props.tTXMText && !this.props.tTXMRequired) {
      this.removeTTXMRequired(this.props.tTXMText)
    }

    if (this.props.qDGQRequired) {
      this.addQDGQRequired(this.props.qDGQText);
    }

    if (this.props.qDGQText && !this.props.qDGQRequired) {
      this.removeQDGQRequired(this.props.qDGQText);
    }
    if (this.state.type == 'TAI_LIEU_DINH_KEM' && this.state.disableAttachFile) {
      this.setState({
        header: [
          { name: 'Stt', width: 45 },
          { name: 'Tên tài liệu', width: 300 },
          { name: 'Số văn bản' },
          { name: 'Ngày ra văn bản' },
          { name: 'Nhóm hồ sơ'},
          { name: 'Tài liệu đính kèm' },
        ]
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tTXMRequired: nextProps.tTXMRequired,
      qDGQRequired: nextProps.qDGQRequired,
      onSave: nextProps.onSave,
      ngayQuyetDinhSuggest: nextProps.ngayQuyetDinhSuggest,
      soVanBanSuggest: nextProps.soVanBanSuggest,
      loaiVanBanSuggest: nextProps.loaiVanBanSuggest,
      disableAttachFile: nextProps.disableAttachFile
    })

    if (nextProps.tTXMRequired) {
      this.addTTXMRequired(nextProps.tTXMText);
    }

    if (nextProps.tTXMText && !nextProps.tTXMRequired) {
      this.removeTTXMRequired(nextProps.tTXMText)
    }

    if (nextProps.qDGQRequired) {
      this.addQDGQRequired(nextProps.qDGQText);
    }

    if (nextProps.qDGQText && !nextProps.qDGQRequired) {
      this.removeQDGQRequired(nextProps.qDGQText);
    }

    if (this.props.dataShow != nextProps.dataShow) {
      this.setState({
        itemsShow: nextProps.dataShow
      });
    }

    if (this.props.data != nextProps.data) {
      this.setState({
        items: nextProps.data
      }, () => {
        if(!this.state.isDsVanBanXuLy) {
          this.addSuggestions();
        }
      });
    }
    if (this.props.oldData != nextProps.oldData) {
      this.setState({
        items: nextProps.oldData
      }, () => {
        if(!this.state.isDsVanBanXuLy) {
          this.addSuggestions();
        }
      });
    }
  }

  addSuggestions() {
    if (!this.state.disableAttachFile) {
      let data = [...this.state.items];
      let dataFilter = data.filter(state => {
        return state.ten == 'Văn bản đính kèm khác' && state.duongDan == ''
      })

      if (dataFilter.length > 0) {
        return
      } else {
        let newItems = {
          ten: 'Văn bản đính kèm khác',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          tenFileds: '',
          duongDan: '',
          progress: '',
          open: false,
          newFile: true,
        }
        this.setState({
          // addSuggestions: true,
          items: [
            ...this.state.items,
            newItems
          ]
        })
      }
    }
  }

  onFileChange(index, data) {
    let newItems = [...this.state.items];

    newItems[index] = data;

    this.state.items = newItems
    this.setState({
      items: this.state.items,
      resetRequired: false,
    });
    this.filterFileChange(newItems, this.props.phanLoaiQuyTrinh);
  }

  filterFileChange(data, type) {
    let newData = [...data];
    let dataFilter = newData.filter(state => {
      return (state.ten != 'Văn bản đính kèm khác' || state.duongDan != '')
    })
    this.props.onFileChange(dataFilter, type);
  }

  addFileDinhKem() {
    let newFile = {};
    if(this.state.isDsVanBanXuLy) {
      if (this.state.type =='TAI_LIEU_DINH_KEM') {
        newFile = {
          ten: '',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          tenFileds: '',
          duongDan: '',
          progress: '',
          open: true,
          required: true
        };
      } else {
        newFile = {
          ten: '',
          tenFile: '',
          tenFileds: '',
          tinhTrang: '',
          duongDan: '',
          taiLieuBangChungId: '',
          open: true,
          required: true
        };
      }
    } else {
      if (this.state.type =='TAI_LIEU_DINH_KEM') {
        newFile = {
          ten: '',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          tenFileds: '',
          duongDan: '',
          progress: '',
          open: true,
        };
      } else {
        newFile = {
          ten: '',
          tenFile: '',
          tenFileds: '',
          tinhTrang: '',
          duongDan: '',
          taiLieuBangChungId: '',
          open: true,
        };
      }
    }

    this.setState({
      items: [
        ...this.state.items,
        newFile
      ]
    });
  }

  handleRemove(index) {
    let newItems = [...this.state.items];
    let idItem = newItems[index].taiLieuVanThuId || newItems[index].taiLieuBangChungId  || newItems[index].taiLieuBaoCaoId;
    newItems.splice(index, 1);
    this.state.items = newItems;
    this.setState({
      items: this.state.items,
      resetRequired: true
    });
    if (idItem) {
      newItems = newItems.filter(state => {
        return (state.ten != 'Văn bản đính kèm khác' || state.duongDan != '')
      });
      this.props.onFileRemove(idItem, newItems, this.props.phanLoaiQuyTrinh);
    } else {
      this.filterFileChange(newItems, this.props.phanLoaiQuyTrinh);
    }
  }

  checkDataTTXM(type, typeText) {
    let data = [...this.state.items];
    let dataCheck = [];
    if (type == 'add') {
      dataCheck = data.filter(state => {
        return (state.required == true && state.typeRequired == typeText)
      });
    }

    if (type == 'remove') {
      dataCheck = data.filter(state => {
        return (state.required == true && state.typeRequired == typeText && (typeof state.newFile == 'undefined' || state.newFile != true))
      });
    }

    let result = ''
    if (dataCheck.length > 0) {
      result = true;
    } else {
      result = false;
    }

    return result
  }

  addTTXMRequired(typeText) {
    if (this.checkDataTTXM('add', typeText)) {
      //DO Nothing
    } else if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO') {
      let itemRequired = {
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        tenFileds: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: typeText,
        newFile: true
      }
      if (this.state.loaiDon == 'DON_KHIEU_NAI') {
        itemRequired.ten = 'Báo cáo Kết quả xác minh nội dung khiếu nại'
      } else if(this.state.loaiDon == 'DON_TO_CAO') {
        itemRequired.ten = 'Báo cáo Kết quả xác minh nội dung tố cáo'
      }
      this.setState({
        items: [
          ...this.state.items,
          itemRequired
        ]
      });
    }
  }

  removeTTXMRequired(typeText) {
    if (this.checkDataTTXM('remove', typeText)) {
      //DO Nothing
    } else {
      let data = [...this.state.items];
      let newItems = data.filter(state => {
        return state.required != true && state.newFile !=true
      })
      this.setState({
        items: newItems
      });
    }

  }

  checkDataQDGQ(type, typeText) {
    let data = [...this.state.items];
    let dataCheck = [];
    if (type =='add') {
      dataCheck = data.filter(state => {
        return (state.required == true && state.typeRequired == typeText)
      });
    }

    if (type == 'remove') {
      dataCheck = data.filter(state => {
        return (state.required == true && state.typeRequired == typeText && (typeof state.newFile == 'undefined' || state.newFile != true))
      });
    }

    let result = ''
    if (dataCheck.length > 0) {
      result = true;
    } else {
      result = false;
    }

    return result
  }

  addQDGQRequired(typeText) {
    if (this.checkDataQDGQ('add', typeText)) {
      //DO Nothing
    } else if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === 'DON_TO_CAO'|| this.state.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' || this.state.loaiDon === 'DON_TRANH_CHAP_DAT'){
      let itemRequired = {
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        tenFileds: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: typeText,
        newFile: true
      }
      if (this.state.loaiDon === 'DON_KHIEU_NAI') {
        if (this.props.quyetDinh === false) {
          itemRequired.ten = 'Quyết định đình chỉ'
        } else {
          itemRequired.ten = 'Quyết định về việc giải quyết khiếu nại'
        }
      } else if (this.state.loaiDon === 'DON_TO_CAO') {
        if (this.props.quyetDinh === false) {
          itemRequired.ten = 'Quyết định đình chỉ'
        } else {
          itemRequired.ten = 'Quyết định về việc giải quyết tố cáo'
        }
      } else if (this.state.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH') {
        if (this.props.quyetDinh === false) {
          itemRequired.ten = 'Quyết định đình chỉ'
        } else {
          itemRequired.ten = 'Văn bản xử lý kiến nghị, phản ánh'
        }
      }
      if (this.state.loaiDon === 'DON_TRANH_CHAP_DAT') {
        if (this.props.quyetDinh === false) {
          itemRequired.ten = 'Văn bản đình chỉ'
        } else {
          itemRequired.ten = 'Văn bản giải quyết'
        }
      }
      this.setState({
        items: [
          ...this.state.items,
          itemRequired
        ]
      });
    }
  }

  removeQDGQRequired(typeText) {
    if (this.checkDataQDGQ('remove', typeText)) {
      //DO Nothing
    } else {
      let data = [...this.state.items]
      let newItems = data.filter(state => {
        return state.required != true && state.newFile !=true
      })
      this.setState({
        items: newItems
      });
    }
  }

  handleReset() {
    this.setState({
      resetRequired: false
    })
  }

  handleUpdateUploading(isUploading) {
    let result = !this.state.isUploading;
    if (typeof isUploading === 'boolean') {
      result = isUploading;
    }
    this.setState({isUploading: result});
  }

  openDialog() {
    this.setState({
      isOpen: true
    })
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    }, () => {
      if (name === 'popupTrung') {
        document.body.className += ' pt-overlay-open';
      }
    });
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target ? e.target.value : e
    })
  }

  onChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  onSearch() {
    const { loaiVanBan, tuNgay, denNgay, soKyHieu } = this.state;

    const payload = {
      loaiVanBan,
      tuNgay: moment(tuNgay).format('YYYY-MM-DD'),
      denNgay: moment(denNgay).format('YYYY-MM-DD'),
      soKyHieu
    }

    this.setState({
      loading: true,
    });

    setTimeout(() => {
      this.setState({
        loading: false,
      });
    }, 1000);
  }

  onSave() {
    this.setState({
      isOpen: false
    })
  }

  renderTable() {
    const { dataTable, loading } = this.state;
    const styles = (fw, fs, lh) => {
      return {
        fontWeight: fw,
        fontSize: fs,
        lineHeight: lh,
      }
    }

    const bodyLoading = (
      <tr className='table-loading'>
        <td colSpan="6">
          <div className='loading-content'>
            <span className='shape1'></span>
            <span className='shape2'></span>
            <span className='shape3'></span>
            <span className='shape4'></span>
            <span className='shape5'></span>
            <span className='shape6'></span>
            <span className='shape7'></span>
            <span className='shape8'></span>
            <span className='shape9'></span>
            <span className='shape10'></span>
            <span className='shape11'></span>
            <span className='shape12'></span>
            <span className='shape13'></span>
          </div>
        </td>
      </tr>
    )

    const bodyEmpty = (
      <tr>
        <td colSpan="6">
          <div style={{
            margin: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '7px'
          }}>
            <img src={emptyFolder} alt="emptyFolder" />
            <p style={styles(400, '13px', '18px')}>Bạn chưa nhập dữ liệu tìm kiếm</p>
            <p style={styles(700, '13px', '18px')}>Vui lòng nhập thông tin để tìm kiếm văn bản ở trên</p>
          </div>
        </td>
      </tr>
    )

    return (
      <div className='wrapper-table'>
        <div className='table-container' style={{ overflowY: 'clip' }}>
          <table className='table-content'>
            <thead className='table-header'>
              <tr>
                {header.taiLieuTrenQLVBDH.map((item, index) => (
                  <th key={index} className='table-header-col' style={{ width: item.width }}>{item.name}</th>
                ))}
              </tr>
            </thead>
            <tbody className='table-body'>
              {loading && isEmpty(dataTable) && bodyLoading}
              {!loading && isEmpty(dataTable) && bodyEmpty}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderDialog() {
    return (
      <Dialog
        isOpen={this.state.isOpen}
        onClose={this.closeDialog.bind(this, 'isOpen')}
        title='Tìm kiếm tài liệu trên QLVBDH'
        className="dialog-them-moi-dttt dialog-default wrap-block"
      >
        <div className='row ml0 mr0'>
          <div className="rows p20">
            <div className="radio-gender col-100">
              <RadioGroup name="loaiVanBan" onChange={this.onChange.bind(this, 'loaiVanBan')} selectedValue={this.state.loaiVanBan}>
                <Radio label="Văn bản đến" value="VAN_BAN_DEN" className="pt-large small-title mb0"/>
                <Radio label="Văn bản đi" value="VAN_BAN_DI" className="pt-large small-title mb0"/>
              </RadioGroup>
            </div>
          </div>
          <span className="line-border"></span>
          <div className='rows p20'>
            <div className='col-83 no-gutter'>
              <DatePicker className="col-33" label="Ngày ban hành từ ngày" bindValidator={this} channel="formTaoDon" endDate={this.state.denNgay} onChange={this.onChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} name='tuNgay' />
              <DatePicker className="col-33" label="Đến ngày" bindValidator={this} channel="formTaoDon" startDate={this.state.tuNgay} onChange={this.onChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} name='denNgay' />
              <Input className='col-33' label="Số ký hiệu" placeholder="Nhập số ký hiệu" value={this.state.soKyHieu} onChange={this.onChange.bind(this, 'soKyHieu')} name='soKyHieu' />
            </div>
            <div className='col-16 mb0-18 search-thanh-tra'>
              <button className={`btn-green ${this.state.loading ? 'btn-loading-inline' : ''}`} onClick={this.onSearch.bind(this)}>Tìm kiếm</button>
            </div>
          </div>
          <span className="line-border"></span>
          <div className="rows">
            <div className="col-100">
              {this.renderTable()}
            </div>
          </div>
        </div>
        <div className="action-form-wrap pt20">
          <div className="box-bottom">
            <Link className="btn-green-no-bd" onClick={this.onSave.bind(this)}><span>Lấy dữ liệu</span></Link>
          </div>
        </div>
      </Dialog>
    )
  }

  render() {
    return (
      <section className="wrap-block row-center" id={this.props.name}>
        {this.renderDialog()}
        <ShowIf condition={this.state.type =='TAI_LIEU_DINH_KEM' && !this.props.hidenTopTitle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <ShowIf condition={!this.props.disableTopLine}>
              <div className="pt5 pb15">
                <span className="line-border"></span>
              </div>
            </ShowIf>
            <h2 className={`title-attach ${this.props.labelClass}`}>
              {this.props.label}
              <ShowIf condition={!this.props.hideDescription && !this.state.disableAttachFile}>
                <span className="attach-file-description"> (Định dạng tập tin đính kèm: .doc, .docx, .pdf, .xls, .xlsx, .rar, .zip, .jpg, .png. Dung lượng tối đa: {this.props.capacity} MB)</span>
              </ShowIf>
            </h2>
            <ShowIf condition={this.props.searchButton && !this.state.disableAttachFile}>
              <Link className="btn-green" onClick={this.openDialog.bind(this)}><i className="tt tt-search"></i>Tìm kiếm văn bản điều hành</Link>
            </ShowIf>
          </div>
        </ShowIf>
        <div className="wrap-big-line white-table">
          <div className={`table-container ${this.props.hidenTopTitle ? 'pt0' : ''}`}>
            <div className='wrapper-table'>
              <table className="table-content">
                <thead className="table-header">
                  <tr>
                    {this.state.header.map((item, i) => {
                      return (
                        <th key={ i } className={ "table-header-col " + (item.className ? item.className : '') } colSpan={ item.colSpan } style={ { width: item.width, minWidth: item.minWidth } }>
                          { item.name }
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody className="table-body">
                  {
                    this.state.itemsShow.map((item, index) => {
                      return (
                        <RowItemShowFileDinhKem key={index} disableAttachFile={this.state.disableAttachFile} type={this.state.type} index={index} {...item}/>
                      )
                    })
                  }
                  {
                    this.state.items.map((item, index) => {
                      return (
                        <RowItemFileDinhKem
                          unSetNgayBanHanh={this.props.unSetNgayBanHanh}
                          checkValidate={this.props.checkValidate}
                          ngayQuyetDinhSuggest={this.state.ngayQuyetDinhSuggest}
                          loaiVanBanSuggest={this.state.loaiVanBanSuggest}
                          soVanBanSuggest={this.state.soVanBanSuggest}
                          key={index}
                          onSave={this.state.onSave}
                          handleReset={this.handleReset.bind(this)}
                          resetRequired={this.state.resetRequired}
                          phanLoaiQuyTrinh={this.props.phanLoaiQuyTrinh}
                          count={this.state.itemsShow.length}
                          isTiepNhanDon={this.props.isTiepNhanDon}
                          bindValidator={this}
                          channel='formTaoDon'
                          type={this.state.type}
                          index={index}
                          onFileChange={this.onFileChange.bind(this, index)}
                          onRemove={this.handleRemove.bind(this, index)}
                          {...item}
                          name={this.props.name}
                          allowExcelFile={true}
                          disabled={this.state.isUploading}
                          onUpdateUploading={this.handleUpdateUploading.bind(this)}
                          isDsVanBanXuLy={this.state.isDsVanBanXuLy}
                          listNhomHoSo={this.state.listNhomHoSo}
                        />
                      )
                    })
                  }
                  <ShowIf condition={!this.state.disableAttachFile}>
                    <tr>
                      <td className="multipe-column" colSpan={this.props.header.length}>
                        <ShowIf condition={this.state.items.length == 0 && this.state.itemsShow.length == 0}>
                          <span className="attach-file-description">Chưa có văn bản xử lý được đính kèm. </span>
                        </ShowIf>
                        <ShowIf condition={!this.state.isUploading}>
                          <Link className="btn-addfile itt-Them-Moi" onClick={this.addFileDinhKem.bind(this)} name={this.props.name}>
                            Thêm mới văn bản
                          </Link>
                        </ShowIf>
                        <ShowIf condition={this.state.isUploading}>
                          <span className="btn-addfile itt-Them-Moi disabled-element">
                            Thêm mới văn bản
                          </span>
                        </ShowIf>
                      </td>
                    </tr>
                  </ShowIf>
                  <ShowIf condition={this.state.disableAttachFile && this.state.itemsShow.length == 0}>
                    <tr>
                      <td className="multipe-column" colSpan={this.props.header.length}>
                        <span className="text-13">Chưa có dữ liệu</span>
                      </td>
                    </tr>
                  </ShowIf>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

ContainerFileDinhKem.defaultProps = {
  label: 'Danh sách Tài liệu đính kèm',
  labelClass: '',
  allowExcelFile: false,
  capacity: 50,
  ngayQuyetDinhSuggest: '',
  soVanBanSuggest: '',
  loaiVanBanSuggest: '',
  items: [],
  dataShow: [],
  data: [],
  oldData: [],
  header: [
    { name: 'Stt', width: 45 },
    { name: 'Tên tài liệu', width: 300 },
    { name: 'Số văn bản' },
    { name: 'Ngày ra văn bản' },
    { name: 'Tài liệu đính kèm' },
    { name: 'Nhóm hồ sơ'},
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  hideDescription: false,
  type: 'TAI_LIEU_DINH_KEM',
  disableAttachFile: false,
  tTXMRequired: false,
  qDGQRequired: false,
  phanLoaiQuyTrinh: '',
  disableTopLine: false,
  onSave: false,
  onFileChange: function() {
    console.log("Please implement 'onFileChange' method");
  },
  name: 'taiLieuDinhKem',
  reload: false,
  isDsVanBanXuLy: false
}

export default validatable(ContainerFileDinhKem);



// WEBPACK FOOTER //
// ./src/components/upload/container-filedinhkem.jsx